import * as CategoryCard from './CategoryCard/CategoryCard.css';
import * as NotificationCard from './NotificationCard/NotificationCard.css';
import * as PromoCodeCard from './PromoCodeCard/PromoCodeCard.css';

export default {
	CategoryCard,
	NotificationCard,
	PromoCodeCard
};
